"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CV_SECTION_LABELS = void 0;
exports.getSectionLabels = getSectionLabels;
exports.getSectionLabel = getSectionLabel;
/**
 * Canonical section labels for CV themes, resolved per locale.
 * Single source — JSON Resume themes re-export these labels.
 * Keys = CVEditingSection enum values (packages/shared/src/types/cv.ts)
 *
 * Translations come from the locale files (CV.* namespace).
 * When adding a locale: register it in translations.ts AND here.
 */
const language_1 = require("../constants/language");
const ar_DZ_json_1 = __importDefault(require("../locales/ar_DZ.json"));
const ar_MA_json_1 = __importDefault(require("../locales/ar_MA.json"));
const de_json_1 = __importDefault(require("../locales/de.json"));
const en_json_1 = __importDefault(require("../locales/en.json"));
const es_json_1 = __importDefault(require("../locales/es.json"));
const es_MX_json_1 = __importDefault(require("../locales/es_MX.json"));
const fr_json_1 = __importDefault(require("../locales/fr.json"));
const pt_json_1 = __importDefault(require("../locales/pt.json"));
const ro_json_1 = __importDefault(require("../locales/ro.json"));
const tr_json_1 = __importDefault(require("../locales/tr.json"));
const uk_json_1 = __importDefault(require("../locales/uk.json"));
/**
 * Reference French labels (legacy, used by getSectionLabel).
 * Theme rendering goes through getSectionLabels(locale).
 */
exports.CV_SECTION_LABELS = {
    personalInfos: 'Informations personnelles',
    competences: 'Compétences',
    skills: 'Compétences',
    languages: 'Langues',
    experiences: 'Expérience professionnelle',
    work: 'Expérience professionnelle',
    personalExperiences: 'Expériences personnelles',
    education: 'Formation',
    hobbiesAndInterests: "Centres d'intérêt",
    interests: "Centres d'intérêt",
    summary: 'À propos',
    complementaryInfo: 'Mentions complémentaires',
    strengths: 'Points forts',
    preferedTasks: 'Tâches préférées',
    notPreferedTasks: 'Tâches non préférées',
    contact: 'Contact',
    profiles: 'Profils',
    references: 'Références',
    awards: 'Mentions complémentaires',
    publications: 'Publications',
    projects: 'Projets',
    certificates: 'Certificats',
    volunteer: 'Expériences personnelles',
    courses: 'Cours',
    highlights: 'Points clés',
    phone: 'Téléphone',
    location: 'Ville',
    present: 'Présent',
};
/**
 * Theme label key -> source key in the CV.* namespace of the locale files
 */
const SECTION_LABEL_SOURCES = {
    summary: 'summary',
    work: 'professionalExperience',
    experiences: 'professionalExperience',
    skills: 'skills',
    languages: 'languages',
    education: 'education',
    interests: 'hobbiesAndInterests',
    hobbiesAndInterests: 'hobbiesAndInterests',
    awards: 'complementaryInfo',
    complementaryInfo: 'complementaryInfo',
    personalExperiences: 'personalExperiences',
    volunteer: 'personalExperiences',
    contact: 'contact',
    phone: 'phone',
    location: 'location',
    publications: 'publications',
    references: 'references',
    projects: 'projects',
    certificates: 'certificates',
    profiles: 'profiles',
    present: 'present',
};
/**
 * Product locale (codeLong) -> CV namespace of the locale file.
 * Keep in sync with translations.ts.
 */
const LOCALE_CV = {
    'fr-FR': fr_json_1.default.CV,
    'en-GB': en_json_1.default.CV,
    'de-DE': de_json_1.default.CV,
    'es-ES': es_json_1.default.CV,
    'es-MX': es_MX_json_1.default.CV,
    'pt-PT': pt_json_1.default.CV,
    'uk-UA': uk_json_1.default.CV,
    'ar-DZ': ar_DZ_json_1.default.CV,
    'ar-MA': ar_MA_json_1.default.CV,
    'tr-TR': tr_json_1.default.CV,
    'ro-RO': ro_json_1.default.CV,
};
/**
 * Localized section labels for a product locale (codeLong, e.g. 'es-MX').
 * No locale -> product default language.
 * Unknown locale or missing translation -> explicit error (no silent fallback).
 */
function getSectionLabels(locale) {
    const code = locale !== null && locale !== void 0 ? locale : language_1.DEFAULT_LANGUAGE;
    const cv = LOCALE_CV[code];
    if (!cv) {
        throw new Error(`CV section labels: unsupported locale "${code}". Supported: ${Object.keys(LOCALE_CV).join(', ')}. Add the locale file and register it in translations.ts and here.`);
    }
    const labels = {};
    for (const [labelKey, sourceKey] of Object.entries(SECTION_LABEL_SOURCES)) {
        const value = cv[sourceKey];
        if (typeof value !== 'string' || value.trim() === '') {
            throw new Error(`CV section labels: missing translation "CV.${sourceKey}" for locale "${code}" (label key "${labelKey}").`);
        }
        labels[labelKey] = value;
    }
    return labels;
}
/**
 * Section label lookup by CVEditingSection id
 */
function getSectionLabel(sectionId) {
    var _a;
    return (_a = exports.CV_SECTION_LABELS[sectionId]) !== null && _a !== void 0 ? _a : sectionId;
}
